import React from 'react';
import styled from 'styled-components';
import Modal from 'react-awesome-modal';

import FroalaEditor from 'react-froala-wysiwyg';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/plugins/colors.min.css'
import 'froala-editor/css/plugins/table.min.css'

import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
// import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
// import 'froala-editor/js/plugins/inline_style.min.js';


import { ModalContent, ModalButton } from '../EditModal/Modal.styles'
import Handle from '../Handle/Handle.Component';

import './Editor.css';

const StyledDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 200px;
    width: 100%;
    border: 2px solid rgba(255, 255, 255, .2);
    border-radius: 5px;
`

const Button = styled.button`
display: ${props => props.show ? 'block' : 'none'} ;
height: 40px;
        width: 160px;
        border-radius: 5px;
        border: 2px #fff solid;
        background-color: rgba(255, 255, 255, .2);
    font: normal normal 22px 'Roboto Condensed';
    text-transform: uppercase;
    color: #fff;
    margin: -16px auto 0 auto;
  `

class EditorInput extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            modalOpen: false,
            showEdit: false,
            model: this.props.text
        }
        this.config = {
            documentReady: true,
            useClasses: true,
            paragraphMultipleStyles: false,
            placeholderText: this.props.text || 'Edit Me',
            fontSizeSelection: true,
            listAdvancedTypes: true,
            fontSize: ['8', '10', '12', '14', '16', '18', '20', '22', '24', '28', '30', '32', '36', '40', '48', '56', '60', '64', '72', '80', '96'],
            fontSizeUnit: 'px',
            fontFamily: {
                "Poppins, sans-serif": "Poppins",
                "Josefin Sans, sans-serif": "Josefin Sans",
                "Roboto,sans-serif": 'Roboto',
                "Oswald,sans-serif": 'Oswald',
                "Montserrat,sans-serif": 'Montserrat',
                "'Open Sans Condensed',sans-serif": 'Open Sans Condensed',
                "'Playfair Display', serif": "Playfair Display"
            },
            toolbarButtons: [
                'fontFamily', 'fontSize', 'inlineStyle', 'insertLink', 'paragraphFormat', 'lineHeight', 'align', 'table', 'color', '|',
                'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|',
                'formatOL', 'formatUL', 'outdent', 'indent', 'quote', , '|',
                'insertLink', 'insertImage', 'embedly', 'insertTable', 'textColor', 'backgroundColor', '|',
                'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|',
                'spellChecker', 'help', '|', 'undo', 'redo'],
            tableResizerOffset: 10,
            tableResizingLimit: 50,
            tableStyles: {
                class1: 'Yellow',
                class2: 'Green',
                class3: 'Blue',
                class4: 'Red'
            },
            colorsText: [
                '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
                '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF',
                '#000000'
            ],
            colorsBackground: [
                '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
                '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
            ],
            colorsStep: 6,
            lineHeights: {
                Default: '',
                Single: '1',
                Double: '2',
                '1.15': '1.15',
                '1.5': '1.5',
                '2.5': '2.5'
            },
            minHeight: 500,
            height: 420,
            pastePlain: false,
            width: 900,
            events: {
                'initialized': function (e, editor) {
                    console.log('Froala Initialized' + editor);
                }
            }
        }
    }

    componentDidMount() {
        this.setState({ model: this.props.text });
    }
    componentWillUpdate() {
        console.log("Editor inoput updating...");
    }
    // componentWillUnmount() {
    //     this.controller.destroy()
    // }
    toggleEditButtons = () => {
        const { showEdit } = this.state;
        this.setState({ showEdit: !showEdit });
    }

    toggleModal = () => {
        const { modalOpen } = this.state;
        this.setState({ modalOpen: !modalOpen });
    }
    openModal = () => {
        this.setState({ modalOpen: true });
    }
    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    closeModalHandler = (colIdx, value) => {
        this.props.editText(colIdx, value);
        this.setState({ modalOpen: false });
    }

    onModelChange = (model) => {
        this.setState({ model });
    }

    deleteAsset = () => {
        this.props.deleteAsset(this.props.columnIndex);
    }

    froalaManualController = (controller) => {
        const editor = controller.getEditor();
        console.log(`Editor: ${editor} and ${JSON.stringify(controller, null, 2)}`);
        if (editor === null) {
            controller.initialize();
        }

    }

    render() {
        return (
            <StyledDiv>
                <Handle type="EDITOR" deleteAsset={this.deleteAsset} />
                <Modal visible={this.state.modalOpen} width="900" height="700" effect="fadeInUp" onClickAway={() => this.closeModal()}>
                    <ModalContent>
                        <FroalaEditor
                            tag='div'
                            config={this.config}
                            model={this.state.model}
                            onModelChange={this.onModelChange}
                            onManualControllerReady={this.froalaManualController}
                        />
                        <ModalButton onClick={this.closeModalHandler.bind(this, this.props.columnIndex, this.state.model)}>Done</ModalButton>
                    </ModalContent>
                </Modal>
                <div style={{ marginBottom: '60px', height: "100%" }} onMouseEnter={this.toggleEditButtons} onMouseLeave={this.toggleEditButtons} >
                    {/* <p style={{ fontSize: `${this.props.size}px`}} onClick={this.props.editText}>{this.state.model}</p> */}
                    <div onClick={this.openModal} style={{ overflowY: 'scroll', height: "100%" }} dangerouslySetInnerHTML={{ __html: this.props.text }} />
                    <Button show={this.state.showEdit} onClick={this.openModal}>Edit</Button>
                </div>
            </StyledDiv>
        )
    }
}

export default EditorInput;


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/EditorInput/Editor.Component.jsx